import { dictionaryReducer } from './reducer';
import { initialDictionaryState } from './state';

const DICTIONARY_MODULE_NAME = 'dictionary';

export { DICTIONARY_MODULE_NAME, initialDictionaryState, dictionaryReducer };
